module.exports = __webpack_public_path__ + "static/media/new_pack_cat_FR_768x350.d63010d6.png";